import { render, staticRenderFns } from "./colorsTab.vue?vue&type=template&id=5ff4d630&scoped=true&"
import script from "./colorsTab.vue?vue&type=script&lang=js&"
export * from "./colorsTab.vue?vue&type=script&lang=js&"
import style0 from "./colorsTab.vue?vue&type=style&index=0&id=5ff4d630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4d630",
  null
  
)

export default component.exports